var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-12 col-lg-6" }, [
          _c("ul", { staticClass: "calendar-legend list-none" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticClass: "pending" }),
              _vm._v(
                " Request " +
                  _vm._s(
                    _vm.$userIsClient
                      ? "Awaiting My Response"
                      : this.$activeClientModuleEnabled
                      ? "Awaiting Client Response"
                      : "Awaiting Agent Response"
                  )
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticClass: "cancelled" }),
              _vm._v(
                " Request " +
                  _vm._s(
                    _vm.$userIsTalent
                      ? "Awaiting My Response"
                      : `Awaiting ${_vm.$options.filters.sentenceCase(
                          _vm.$starLabel
                        )} Response`
                  )
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-sm-12 col-lg-6" },
          [
            _vm.$userIsAdmin || _vm.$userIsManager
              ? [
                  _c("h3", { staticClass: "m-t-none" }, [
                    _vm._v(
                      "Show " +
                        _vm._s(_vm._f("sentenceCase")(_vm.$starLabel)) +
                        " Calendars"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("selectize", {
                    staticClass: "form-control selectize selectize-multiple",
                    attrs: {
                      name: "talent",
                      options: _vm.talentOptions,
                      multiple: "",
                      "pre-load": true,
                      "fetch-results": _vm.fetchTalentCallback,
                      "fetch-more-results": _vm.fetchMoreTalentCallback,
                    },
                    model: {
                      value: _vm.talentCalendars,
                      callback: function ($$v) {
                        _vm.talentCalendars = $$v
                      },
                      expression: "talentCalendars",
                    },
                  }),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-12" },
          [
            _c(
              "div",
              { staticClass: "fc-loading-container" },
              [_c("pickstar-loading")],
              1
            ),
            _vm._v(" "),
            _c("full-calendar", {
              ref: "calendar",
              attrs: {
                "event-sources": _vm.eventSources,
                selectable: false,
                editable: false,
                config: _vm.config,
              },
              on: {
                "day-click": _vm.handleDayClickCallback,
                "event-selected": _vm.handleEventSelectedCallback,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "margin-20" }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("Calendar")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("span", { staticClass: "booked" }),
      _vm._v(" Booked Event"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }